import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { INotification } from 'src/interfaces';

export interface NotificationState {
  notificationsSendCount: number
  notifications: INotification[]
}

const initialState: NotificationState = {
  notificationsSendCount: 0,
  notifications: []
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction< INotification[]>) {
      state.notifications = action.payload;
    },

    setNotificationsSendCount(state, action: PayloadAction<number>) {
      state.notificationsSendCount = action.payload;
    },
  },
});

export const {
  setNotifications,
  setNotificationsSendCount
} = notificationSlice.actions;

export default notificationSlice.reducer;
